import styled from 'styled-components';
import '../../styles/GlobalThemeStyle';
import Lottie from 'lottie-react';
import { Card, Button, Divider } from 'antd';

export const XThemeButtonRounded = styled(Button)`
	width: 100%;
	position: relative;
	background: ${({ theme }) => theme.CQColors.gradientBg};
	border: 1px solid ${({ theme }) => theme.CQColors.borderColor};
	box-shadow: none !important;
	border-radius: 10px;
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	color: ${({ theme }) => theme.CQColors.white} !important;
	font-family: ${({ theme }) => theme.CQColors.Inter};
	img,
	svg {
		width: 20px !important;
		font-size: 20px;
		filter: ${({ theme }) => theme.CQColors.imgFilterWhite};
	}
	&:hover {
		background: ${({ theme }) => theme.CQColors.white} !important;
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		border: 1px solid ${({ theme }) => theme.CQColors.secondaryColor} !important;
		img,
		svg {
			filter: ${({ theme }) => theme.CQColors.imgFilterColor} !important;
		}
	}
	&:disabled {
		background: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		border-color: ${({ theme }) =>
			theme.CQColors.secondaryColor} !important;
		color: ${({ theme }) => theme.CQColors.white} !important;
		cursor: not-allowed !important;
		opacity: 0.6;
		img,
		svg {
			filter: ${({ theme }) => theme.CQColors.imgFilterWhite} !important;
		}
	}
	/* &:hover:not(:disabled) {
		background: ${({ theme }) => theme.CQColors.bodyBg} !important;
		border-color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		color: ${({ theme }) => theme.CQColors.themeColor1} !important;
	} */
	&.noBackground {
		background: ${({ theme }) => theme.CQColors.white} !important;
		color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		border: 1px solid ${({ theme }) => theme.CQColors.secondaryColor} !important;
		img,
		svg {
			filter: ${({ theme }) => theme.CQColors.imgFilterColor} !important;
		}
		&:hover {
			background: ${({ theme }) => theme.CQColors.gradientBg} !important;
			border: 1px solid ${({ theme }) => theme.CQColors.secondaryColor};
			color: ${({ theme }) => theme.CQColors.white} !important;
			img,
			svg {
				filter: ${({ theme }) =>
					theme.CQColors.imgFilterWhite} !important;
			}
		}
	}
	@media only screen and (max-width: 767.99px) {
	}
`;

export const XButtonRounded = styled(Button)`
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.colors.color6};
	color: ${({ theme }) => theme.colors.menu2};
	border-radius: 10px !important;
	box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
	img,
	svg {
		width: 18px !important;
	}
	&:hover:not(:disabled) {
		background: ${({ theme }) => theme.colors.white} !important;
		border-color: ${({ theme }) => theme.colors.color6} !important;
		color: ${({ theme }) => theme.colors.menu2} !important;
	}
	.rotateButton {
		transform: rotate(3.142rad);
	}

	@media only screen and (max-width: 767.99px) {
	}
`;
